// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blb-add-network-config-wrapper-4d3b0{background-color:#fff;margin:16px;padding:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"network-config-wrapper": "blb-add-network-config-wrapper-4d3b0",
	"networkConfigWrapper": "blb-add-network-config-wrapper-4d3b0"
};
export default ___CSS_LOADER_EXPORT___;
